// react
import React, { useEffect, useState } from 'react';
// components
import { Input, message, Rate } from 'antd';
// apis & store & utils
import { getBookingDetail } from '../../api/request';
import { getValue } from '../../utils';
import './personalEvaluate.less';

/**
 * @description booking detail 评价
 * @param {*} props
 * @returns {*} booking detail
 */
export const cry = require('./../../assets/images/evaluate/cry.png');
export const kulian = require('./../../assets/images/evaluate/kulian.png');
export const xiaolian = require('./../../assets/images/evaluate/xiaolian.png');
export const cryActive = require('./../../assets/images/evaluate/cryActive.png');
export const kulianActive = require('./../../assets/images/evaluate/kulianActive.png');
export const xiaolianActive = require('./../../assets/images/evaluate/xiaolianActive.png');
const PersonalEvaluate = (props) => {

    const { TextArea } = Input;

    const bookingWay = {
        100529221: '电话',
        100529222: '直播',
        100529223: '面授'
    };
    const arrySatisfy = ['很差', '较差', '一般', '满意', '超赞'];
    // 提交的服务建议
    const [serviceAdvice, setServiceAdvice] = useState('');

    // booking detail 详情
    const [bookingDetail, setBookingDetail] = useState({});
    // booking detail 详情
    const [raiseData, setRaiseData] = useState({
        contentValue: 0,  // 1-5评分
        teachingAttitude: 0, // 1-5评分
        networkQuality: 0, // 1-5评分
        isLike: 0, // 5 差评，  6 一般， 3 满意
    });
    /**
     * @description 获取booking详情
     */
    const _getBookingInfo = async () => {
        const params = {
            id: props.bookingDetailId,
            cancel: 0
        };
        const { data } = await getBookingDetail(params);
        if (!data.status) {
            const bookingDetailInfo = getValue(() => data.result);
            setBookingDetail(bookingDetailInfo);
        } else {
            message.warning(data.message || data.info);
        }
    };

    /**
     * @description 提交数据给父组件
     */
    const handlePropData = () => {
        props.commitData({
            id: props.bookingDetailId,
            studentComment: serviceAdvice,
            evaluationSource: 1,
            ...raiseData
        });
    };

    /**
     * @description 改变状态
     */
    useEffect(() => {
        handlePropData();
    }, [serviceAdvice, raiseData]);

    /**
     * @description 生命周期 api请求
     */
    useEffect(() => {
        _getBookingInfo();
    }, []);

    /**
     * @description item
     */

    return (
        <div>
            <div className="detail-form">
                <div className="main-evaluate">
                    <div className="title">
                        满意程度
                    </div>
                    <div className="evaluate">
                        <li onClick={() => setRaiseData({ ...raiseData, isLike: 5 })}>
                            <img src={raiseData.isLike === 5 ? kulianActive : kulian} />
                            <p className={raiseData.isLike === 5 ? 'active' : ''}>差评</p>
                        </li>
                        <li onClick={() => setRaiseData({ ...raiseData, isLike: 6 })}>
                            <img src={raiseData.isLike === 6 ? cryActive : cry} />
                            <p className={raiseData.isLike === 6 ? 'active' : ''}>一般</p>
                        </li>
                        <li onClick={() => setRaiseData({ ...raiseData, isLike: 3 })}>
                            <img src={raiseData.isLike === 3 ? xiaolianActive : xiaolian} />
                            <p className={raiseData.isLike === 3 ? 'active' : ''}>满意</p>
                        </li>
                    </div>
                </div>
                <div className="evaluate-star">
                    <li>
                        <span>内容价值</span><Rate
                            onChange={(v) => setRaiseData({ ...raiseData, contentValue: v })} />
                        {raiseData.contentValue ? <a>{arrySatisfy[raiseData.contentValue - 1]}</a> : null}
                    </li>
                    <li>
                        <span>教学态度</span><Rate
                            onChange={(v) => setRaiseData({ ...raiseData, teachingAttitude: v })} />
                        {raiseData.teachingAttitude ? <a>{arrySatisfy[raiseData.teachingAttitude - 1]}</a> : null}
                    </li>
                    <li>
                        <span>网络质量</span><Rate
                            onChange={(v) => setRaiseData({ ...raiseData, networkQuality: v })} />
                        {raiseData.networkQuality ? <a>{arrySatisfy[raiseData.networkQuality - 1]}</a> : null}
                    </li>
                </div>
                <div className="detail-row">
                    <div className="suggest-title">服务建议：</div>
                    <div className="text-area">
                        <TextArea
                            maxLength={200}
                            onChange={e => setServiceAdvice(e.target.value)}
                            placeholder="为了让老师可以以后更好地为您服务，建议同学能留下宝贵的建议"
                            rows={5}
                            value={serviceAdvice} />
                        <span>{serviceAdvice.length}/200</span>
                    </div>
                </div>
            </div>
            <div className="suggest-title">我的预约服务</div>
            <div className="detail-form">
                <div className="detail-row clear">
                    <div className="row-left fl"><span>上课科目：</span><span className="detail-content">{bookingDetail.subjectName}</span></div>
                    <div className="row-right fl"><span>上课时间：</span><span className="detail-content">{bookingDetail.timeRange}</span></div>
                </div>
                <div className="detail-row clear">
                    <div className="row-left fl"><span>手机号码：</span><span className="detail-content">{bookingDetail.reserveMobile}</span></div>
                    <div className="row-right fl"><span>上课方式：</span><span className="detail-content">{bookingWay[bookingDetail.serviceType]}</span></div>
                </div>
            </div>
        </div>
    );
};

export default PersonalEvaluate;